import React from 'react';
import type ServiceDeskCmdbInsightObjectView from '@atlassian/jira-spa-apps-servicedesk-cmdb-object-v2/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskCmdbObjectV2 = lazyForPaint<typeof ServiceDeskCmdbInsightObjectView>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-cmdb-object-v2", jiraSpaEntry: "async-servicedesk-cmdb-object-v2" */ '@atlassian/jira-spa-apps-servicedesk-cmdb-object-v2'
		),
);

export const InsightCmdbObjectViewV2 = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskCmdbObjectV2}
		pageId="spa-apps/servicedesk/insight/cmdb-object-v2"
		shouldShowSpinner
	/>
);

export default InsightCmdbObjectViewV2;
